import { render, staticRenderFns } from "./SystemRoleSettings.vue?vue&type=template&id=b26af0b2&scoped=true"
import script from "./SystemRoleSettings.vue?vue&type=script&lang=js"
export * from "./SystemRoleSettings.vue?vue&type=script&lang=js"
import style0 from "./SystemRoleSettings.vue?vue&type=style&index=0&id=b26af0b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b26af0b2",
  null
  
)

export default component.exports